<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  export default {
    data () {
      return {
        
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    watch: {

    },
    computed: {
      
    },
    mounted () {
      
    },
    methods: {
      config () {
        return {
          // CONFIG PARSING API
          api: `admin/salary/history?user_id=${this.$route.params.id}`,

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: false,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Kode',
              width: '200px',
              value: 'code',
              sortable: false,
              freeze: false,
              hide: false
            },
            {
              text: 'Nama Lengkap',
              width: '400px',
              value: 'name',
              sortable: false,
              freeze: false,
              hide: false
            },
            {
              text: 'Gaji Pokok',
              width: '200px',
              value: 'basic_value',
              sortable: false,
              freeze: false,
              hide: false,
              format: 'number'
            },
            {
              text: 'Tunjangan Tetap',
              width: '200px',
              value: 'fixed_value',
              sortable: false,
              freeze: false,
              hide: false,
              format: 'number'
            },
            {
              text: 'Tunjangan Tidak Tetap',
              width: '200px',
              value: 'non_fixed_value',
              sortable: false,
              freeze: false,
              hide: false,
              format: 'number'
            },
            {
              text: 'Posisi',
              width: '200px',
              value: 'position',
              sortable: false,
              freeze: false,
              hide: false
            },
            {
              text: 'Tanggal',
              width: '200px',
              value: 'date',
              sortable: false,
              freeze: false,
              hide: false,
              format: 'date'
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // CONFIG PARSING FORM
          form: [],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            edit: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            delete: {
              button: false,
              api: ''
            },
            detail: {
              button: false,
              api: ''
            },
            attachment: {
              button: false,
              api: ''
            },
            active: {
              button: false,
              api: ''
            },
            deactive: {
              button: false,
              api: ''
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            reset: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: true,
              api: ''
            }
          }
        }
      }
    }
  }
</script>